import React from 'react';

import { ArrowUp } from 'lucide-react';

export const LeadershipResilience = () => {
    const scorePct = 72;
    const deltaPct = 2;
    const employeesAssessed = 45;
    const simulationsTaken = 125;

    return (
        <div className='card card--md card--radius-sm dashboard__stats_card__mbts__leadership_resilience'>
            <p className='text-medium'>Leadership Resilience</p>
            <div className="dashboard__stats_card__mbts__leadership_resilience__content">
                <div className="dashboard__stats_card__mbts__leadership_resilience__content__left">
                    <div
                        className="dashboard__stats_card__mbts__leadership_resilience__donut"
                        style={{ ['--progress' as unknown as string]: scorePct } as React.CSSProperties}
                        role="img"
                        aria-label={`Leadership resilience score ${scorePct}%`}
                    >
                        <p className="text-2xl text-semibold text-center">
                            {scorePct}%
                        </p>
                    </div>

                    <div className="d-flex align-items-center gap-sm">
                        <div className="d-flex align-items-center gap-xs">
                            <ArrowUp size={20} className='color--success-strong' />
                            <p className="text-sm text-medium color--success-strong">{deltaPct}%</p>
                        </div>
                        <p className="text-sm text-medium color--txt-muted">vs last month</p>
                    </div>
                </div>
                <div className="dashboard__stats_card__mbts__leadership_resilience__content__right">
                    <div className='d-flex flex-column justify-content-between align-items-end gap-xl'>
                        <div>
                            <p className='text-4xl text-semibold text-right mb-md'>{employeesAssessed}</p>
                            <p className='text-sm text-medium color--txt-muted text-right'>Users Assessed</p>
                        </div>
                        <div>
                            <p className='text-4xl text-semibold text-right mb-md'>{simulationsTaken}</p>
                            <p className='text-sm text-medium color--txt-muted text-right'>Simulations Taken</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};